// extracted by mini-css-extract-plugin
export var bodyRow = "_fp-d";
export var cardColumns = "_fp-e";
export var ellipsesOverflow = "_fp-2";
export var flatBottomCorners = "_fp-3";
export var flatTopCorners = "_fp-4";
export var headerActionsDropdown = "_fp-f";
export var headerBottomRow = "_fp-c";
export var headerTopRow = "_fp-b";
export var orderDetailsWrapper = "_fp-0";
export var orderInfoContainer = "_fp-1";
export var productDetails = "_fp-9";
export var productImage = "_fp-5";
export var responsiveTable = "_fp-8";
export var shipmentContainer = "_fp-a";
export var tableBottomLeft = "_fp-6";
export var tableBottomRight = "_fp-7";